module.exports = __webpack_public_path__ + "static/media/background.595832c5.png";